import { useEffect, useMemo, useState } from 'react';

import { AffiliateBaseThemeType, ChatBaseThemeType, createTheme } from '@repo/styles';

export default function useTheme<T extends AffiliateBaseThemeType | ChatBaseThemeType>(baseTheme: T) {
  const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains('dark'));

  useEffect(() => {
    const handleDarkModeToggle = () => {
      setIsDarkMode(document.body.classList.contains('dark'));
    };

    const observer = new MutationObserver(handleDarkModeToggle);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => {
      observer.disconnect();
    };
  }, []);
  const theme = useMemo(() => createTheme(isDarkMode ? 'dark' : 'light', baseTheme), [isDarkMode, baseTheme]);

  return { theme };
}
